import { Close, WarningAmber } from "@mui/icons-material";
import { IconButton, Snackbar, Typography } from "@mui/material";
import React from "react";

interface SnackbarProps {
  primaryText: string;
  additionalText: string;
  isOpen: boolean;
  onClose: () => void;
}

const ErrorMessage: React.FC<SnackbarProps> = ({
  primaryText,
  additionalText,
  isOpen,
  onClose,
}) => {
  const close = (
    <IconButton
      size="small"
      aria-label="close"
      color="inherit"
      onClick={onClose}
      style={{ position: "absolute", top: "8px", right: "8px" }}
    >
      <Close fontSize="small" />
    </IconButton>
  );

  return (
    <Snackbar
      open={isOpen}
      message={
        <>
          <Typography
            color="black"
            fontFamily="Lato"
            fontSize="16px"
            fontStyle="normal"
            fontWeight={700}
            lineHeight="normal"
            display="flex"
            alignItems="center"
          >
            <WarningAmber sx={{ marginRight: "8px", fill: "#323232" }} />
            {primaryText}
          </Typography>
          <Typography
            color="black"
            fontFamily="Lato"
            fontSize="14px"
            fontStyle="normal"
            fontWeight={400}
            lineHeight="normal"
          >
            {additionalText}
          </Typography>
        </>
      }
      autoHideDuration={5000}
      onClose={onClose}
      action={close}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      ContentProps={{
        sx: {
          border: "1px solid",
          borderLeft: "4px solid",
          borderColor: "#ed0812",
          color: "black",
          bgcolor: "#ffdee5",
          width: "300px",
        },
      }}
    ></Snackbar>
  );
};

export default ErrorMessage;
